import React from "react";
import PropTypes from "prop-types";
import TripMasterDocumentTitleHelmet from "./TripMasterDocumentTitleHelmet";
import { buildTripMasterStaticPageTitle } from "./tripMasterDocumentTitle";

/** Static public routes outside VacationPackagesPublicFlow (contact, terms, booking). */
export default function TripMasterStaticPageTitle({ pageLabel }) {
  return <TripMasterDocumentTitleHelmet title={buildTripMasterStaticPageTitle(pageLabel)} />;
}

TripMasterStaticPageTitle.propTypes = {
  pageLabel: PropTypes.string.isRequired,
};
